export const onScrollTop = () => {
  const element = document.getElementById("content");
  element.scrollTo({
    top: 0,
    left: 0,
    behavior: "smooth"
  });
};
